import React, { useEffect } from "react"
import * as wijmo from '@grapecity/wijmo';
import {
  Card, CardContent, CircularProgress, Typography
} from "@material-ui/core";
import '../static/css/QAListResult.css'
import { CollectionView } from '@grapecity/wijmo';
import { Resultcustomer } from './qalistresult/role/customer'
import { Resultemployee } from './qalistresult/role/employee'
import { useGlobalState } from "../provider/Provider";
import { cisUser, getSessionStorage, isSessionStorage } from "../User";

const rolecustomer = process.env.REACT_APP_ROLE_CUSTOMER!

interface Prop {
  tableTitle: string,
  pageSize: number,
  handleClickQAno: (num: string) => void,
  loading: boolean
}

const QAListResult: React.FC<Prop> = (props) => {
  const globalState = useGlobalState('user')
  const { backpage } = useGlobalState('page')
  const globalqalistState = useGlobalState('qalist')
  const { role } = globalState
  const { tableTitle, handleClickQAno, loading, pageSize } = props
  const [data, setData] = React.useState<CollectionView<any> | string>('')
  const [open, setOpen] = React.useState<boolean>(false)
  const headerRef = React.useRef(null)
  const transQAEdit = (ctx: any, event: any, menuEditId: string) => {//ctx: ICellTemplateContext
    //qaListResult param stored sessionstorage
    try {
      if (headerRef && headerRef.current) {
        const qaresult = {
          //@ts-ignore
          pageindex: headerRef?.current?.props.cv.pageIndex,
          pagesort: {
            //@ts-ignore
            property: headerRef?.current?.props.cv.sortDescriptions.length === 0 ? undefined : headerRef?.current?.props.cv.sortDescriptions[0].property,
            //@ts-ignore
            ascending: headerRef?.current?.props.cv.sortDescriptions.length === 0 ? undefined : headerRef?.current?.props.cv.sortDescriptions[0].ascending
          },
        }
        const setstr = unescape(encodeURIComponent(JSON.stringify(qaresult)))
        sessionStorage.setItem('SESSIONLIST', btoa(setstr));
      }
    } catch (err) {
      if (err.message.match(/exceeded the quota/)) {
        console.log('Session Storage is full')
      } else { console.log(err) }
    }
    if (ctx.value) {
      handleClickQAno(ctx.value)
    }
  }

  useEffect(() => {
    let cleanup = false;
    if (globalqalistState.length === 0) {
      setOpen(false)
      if (!cleanup) { setData('該当するQ&Aはありません') }
    } else {
      if (!cleanup) {
        const setDataPage = (): CollectionView<any> => {
          return new CollectionView(globalqalistState, {
            pageSize: pageSize,
          })
        }
        setOpen(true)
        setData(setDataPage())
      }
    }
    return () => { cleanup = true }
  }, [globalqalistState])

  useEffect(() => {
    if (data && typeof data !== 'string' && backpage && isSessionStorage()) {
      const [pageindex, pagesort] = getSessionStorage()
      if (pagesort && typeof (pagesort.ascending) === 'boolean' && pagesort.property) {
        data.sortDescriptions.push(new wijmo.SortDescription(pagesort.property, pagesort.ascending))
      }
      data.moveToPage(pageindex)
    }
  }, [data, backpage, isSessionStorage()])

  return (
    <React.Fragment>
      <Card>
        <CardContent>
          <Typography variant="h5" component="h2">{tableTitle}</Typography>
          {loading ? <div style={{ textAlign: "center" }}><CircularProgress /></div> : (
            <React.Fragment>
              {role === rolecustomer && <Resultcustomer open={open} data={data} tableTitle={tableTitle} transQAEdit={transQAEdit} headerRef={headerRef} />}
              {cisUser(role) && <Resultemployee open={open} data={data} tableTitle={tableTitle} transQAEdit={transQAEdit} headerRef={headerRef} />}
            </React.Fragment>
          )
          }
        </CardContent>
      </Card>
    </React.Fragment>
  )
}

export default QAListResult